<template>
	<div class="upsell-container">
		<mq-layout mq="desktop">
			<h2>Choose an item to add to your cart:</h2>
			<div class="upsell-item-container menu-items">
				<BaseLoader v-if="!upsellItems" />
				<div v-for="item in upsellItems()" :key="item.id" class="menu-card">
					<menu-item :item="item" :afterClick="closeModal"/>
				</div>
			</div>
		</mq-layout>
		<mq-layout :mq="['mobile','tablet']" class="full-width">
			<menu-item-rows :items="upsellItems()" :afterClick="closeModal"/>
		</mq-layout>
		<div class="upsell-options">
			<BaseButton title="No, thank you."
				:bigBtn="true"
				@click.native="hideUpsell" />
		</div>
	</div>
</template>

<script>
	import upsellMixin from '@/components/mixins/upsellMixin';
	import itemMixin from '@/components/mixins/itemMixin';
	import MenuItem from '@/components/menu/MenuItem/MenuItem.vue';
	import MenuItemRows from '@/components/menu/common/MenuItemRows.vue';

	export default {
		mixins: [upsellMixin, itemMixin],
		components: {
			'menu-item': MenuItem,
			'menu-item-rows': MenuItemRows,
		},
		data() {
			return {
				upsellItems: () => {
					let items = [];
					const vue = this;
					const useItemIds = _.slice(this.getUpsellItems, 0, 3);
					_.each(useItemIds, (upsellItemId) => {
						items.push(vue.getItemWithId(upsellItemId));
					});
					return items;
				},
			};
		},
		methods: {
			closeModal() {
				this.$modal.hide('contentModal');
			},
			hideUpsell() {
				this.setShowUpsellOff();
				this.closeModal();
			},
			goHome() {
				this.$router.push({ path: '/' });
				this.closeModal();
			},
		},
		created() {
			this.setupUpsellItems();
		},
		mounted() {
			this.$tpa.trackUpsellPage();
		}
	}
</script>

<style lang="scss" scoped>
	@import 'globalStyles';
	@import 'commonStyle/menuCard';
	
	.menu-category-wrapper {
		display: flex;
		justify-content: center;

		padding-top: 1rem;

		background-color: $menu_background;
	}
	.menu-card {
		margin: 1rem 0.25rem;
	}
	.menu-items {
		display: flex;
		flex-wrap: wrap;
	}
	.upsell-container {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		.upsell-options {
			margin-top: 0;
		}
		h2 {
			max-width: 80vw;
			font-size: 16pt;
			font-weight: bold;
		}
	}
	@include desktop {
		.upsell-container {
			height: 460px;

			.menu-items {
				flex-wrap: nowrap;
			}

			h2 {
				margin-bottom: 1rem;
				text-align: center;
			}

			.upsell-options {
				display: flex;
				align-items: center;
				justify-content: center;

				width: 80%;
			}
			.upsell-text {
				margin: 0 2rem;
			}
		}
	}
	@include mobile {
		.upsell-container {
			height: 100vh;
			width: 100%;
			justify-content: flex-start;

			.upsell-item-container {
				margin-top: 0;
			}
			.upsell-options {
				position: relative;
				top: 0;

				margin: 1rem;
				.upsell-text {
					margin: 0.5rem 0;

					width: 100%;

					text-align: center;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/checkout/Upsell.vue